module.exports = __webpack_public_path__ + "img/icon-search.6d6dcca6.svg";